import mobx, { observable, computed, action, runInAction, observe } from 'mobx';
import { serializable, identifier, update, deserialize, serialize, object, list } from 'serializr';
import TcFileResource from './tcfile-resource';
import AgentResource from '../agents/agent-resource';
import OfficeResource from './office-resource';
import PropertyTypeResource from './propertytype-resource';
import TcFileModel from './tcfile-model';
import ModelSchemas from '../shared/model-schema';
import FilterOptions from './../shared/filter-options';
import Agent from '../agents/agent-model';
import Coordinator from '../coordinators/coordinator-model';
import _ from 'lodash';
import Cons from '../../isomorphic/cons';
import { createViewModel } from 'mobx-utils';
import moment from 'moment';
import Notifications from '../utils/notification-helper';
import PrimeResource from '../resources/prime-resouce';
import AgentProfileModel from '../agent-profile/agent-profile-model';
import AgentProfileResource from '../agent-profile/agent-profile-resource';

export default class TcFileStore {
    @observable isLoading = false;
    @observable isSaving = false;
    @observable selectedFile = new TcFileModel();
    @observable selectedFileContacts = [];
    @observable newListing = {};
    @observable newTransaction = {};
    @observable fileAgent = {};

    lookupAgentOffices = observable.array([]);
    lookupAgentPropertyTypes = observable.array([]);
    duplicateFiles = observable.array([]);

    hasErrors = false;
    selectedFileViewModel;
    files = observable.map();
    @observable filesCount = 0;
    lookupFiles = observable.array([]);
    lookupAgents = observable.array([]);
    lookupSubscriberNames = observable.array([]);
    appStore;
    tcFileResource;
    agentResource;
    officeResource;
    propertyTypeResource;

    constructor(appstore) {
        this.appStore = appstore;
        this.tcFileResource = new TcFileResource();
        this.agentResource = new AgentResource();
        this.agentProfileResource = new AgentProfileResource();
        this.officeResource = new OfficeResource();
        this.propertyTypeResource = new PropertyTypeResource();
        this.primeResource = new PrimeResource();
    }

    @action
    updateSelected(json) {
        this.isLoading = true;
        // delete json.agents
        // delete json.coordinators
        // TODO:  Figure out serialization and de(serialization)
        // Not sure this belongs here
        _.assign(this.selectedFileViewModel, json);
        let dirtyProperties = [];
        _.each(json, (value, key) => {
            if (this.selectedFileViewModel.isPropertyDirty(key)) {
                dirtyProperties.push(key);
            }
        });
        //Submit properties to actual model
        //this.selectedFileViewModel.submit()

        return this.tcFileResource
            .saveTcFile(this.appStore.authStore.getAccessToken(), this.selectedFileViewModel, dirtyProperties)
            .then(({ body }) => {
                this.isLoading = false;
                return this.reloadselectedFileAndWorkflow(body.tcFileId);
            })
            .catch((err) => {
                this.isLoading = false;

                return err;
            });
    }

    @action
    loadFile(tcFileId) {
        this.selectedFile = null;
        return this.tcFileResource
            .getTcFileById(this.appStore.authStore.getAccessToken(), tcFileId)
            .then((tcFileModel) => {
                runInAction(() => {
                    this.selectedFile = new TcFileModel();
                    _.assign(this.selectedFile, tcFileModel);
                    if (this.selectedFile.actualCloseDate)
                        this.selectedFile.actualCloseDate = moment(this.selectedFile.actualCloseDate).format();

                    if (this.selectedFile.estimatedCloseDate)
                        this.selectedFile.estimatedCloseDate = moment(this.selectedFile.estimatedCloseDate).format();

                    if (this.selectedFile.depositDate)
                        this.selectedFile.depositDate = moment(this.selectedFile.depositDate).format();

                    if (this.selectedFile.fileSubmissionDate)
                        this.selectedFile.fileSubmissionDate = moment(this.selectedFile.fileSubmissionDate).format();

                     if (this.selectedFile.expirationDate)
                         this.selectedFile.expirationDate = moment(this.selectedFile.expirationDate).format();
                    
                    this.selectedFileViewModel = createViewModel(this.selectedFile);
                    this.isLoading = false;
                });
            });
    }

    @action
    loadFileContacts() {
        this.getContactsForSelectedFile()
            .then((contacts) => {
                this.selectedFileContacts.replace(contacts);
                return this.getSkySlopeFileForSelectedFile();
            })
            .then((listingOrTransaction) => {
                const additionalContacts = [];
                let firstName = this.selectedFile.agent.name
                        .split(' ')
                        .slice(0, -1)
                        .join(' '),
                    lastName = this.selectedFile.agent.name
                        .split(' ')
                        .slice(-1)
                        .join(' ');
                if (this.selectedFile.agent.name.split(' ').length === 0) {
                    firstName = this.selectedFile.agent.name;
                }
                additionalContacts.push({
                    email: this.selectedFile.agent.correspondenceEmail,
                    firstName,
                    lastName,
                    contactTypeId: Cons.prime.fileContactType.FileAgent,
                });
                additionalContacts.push({
                    email: listingOrTransaction.PortalEmail,
                    name: 'Property',
                    contactTypeId: Cons.prime.fileContactType.PortalEmail,
                });
                this.selectedFileContacts.replace(this.selectedFileContacts.slice().concat(additionalContacts));
            });
    }

    reloadselectedFileAndWorkflow(tcFileId) {
        this.isLoading = true;
        this.selectedFile = null;
        return this.tcFileResource
            .getTcFileById(this.appStore.authStore.getAccessToken(), tcFileId)
            .then((tcFileModel) => {
                runInAction(() => {
                    if (tcFileModel.actualCloseDate)
                        tcFileModel.actualCloseDate = moment(tcFileModel.actualCloseDate).format();

                    if (tcFileModel.estimatedCloseDate)
                        tcFileModel.estimatedCloseDate = moment(tcFileModel.estimatedCloseDate).format();

                    if (tcFileModel.depositDate) tcFileModel.depositDate = moment(tcFileModel.depositDate).format();

                    if (tcFileModel.fileSubmissionDate)
                        tcFileModel.fileSubmissionDate = moment(tcFileModel.fileSubmissionDate).format();
                     
                    if (tcFileModel.expirationDate)
                         tcFileModel.expirationDate = moment(tcFileModel.expirationDate).format();

                    this.selectedFile = tcFileModel;
                    this.selectedFileViewModel = createViewModel(this.selectedFile);
                    this.appStore.viewStore.selectedFileId = tcFileId;
                });
            })
            .then(() => {
                return this.loadFileContacts();
            })
            .then(() => {
                return this.appStore.workflowStore.loadWorkflow();
            })
            .then(() => {
                return this.appStore.workflowStore.loadTimelineEvents();
            })

            .then(() => {
                this.isLoading = false;
            })
            .catch((err) => {
                this.isLoading = false;
                return err;
            });
    }

    @action
    loadFiles() {
        this.isLoading = true;

        const countPromise = this.tcFileResource.getFilesExtendedSearchCount(
            this.appStore.authStore.getAccessToken(),
            this.appStore.viewStore.fileTableViewOptions.filter
        );
        const filesPromise = this.tcFileResource.getFilesExtendedSearch(
            this.appStore.authStore.getAccessToken(),
            this.appStore.viewStore.fileTableViewOptions.filter
        );

        return Promise.all([countPromise, filesPromise]).then((results) => {
            runInAction(() => {
                this.filesCount = results[0];
                this.updateFiles(results[1]);
                this.isLoading = false;
            });
        });
    }

    @action.bound
    addFileAddressSelected(selectedAddresses) {
        const selectedAddress = _.first(selectedAddresses);
        this.appStore.analytics.trackFileAction(null, `IMPORTING`, { address: selectedAddress });

        const fileType = selectedAddress.TransactionId ? Cons.fileTypes.transaction : Cons.fileTypes.listing;
        const id = fileType === Cons.fileTypes.transaction ? selectedAddress.TransactionId : selectedAddress.ListingId;

        const filter =
            fileType === Cons.fileTypes.listing
                ? {
                      where: {
                          and: [
                              { originId: id },
                              {
                                  status: {
                                      inq: [
                                          Cons.fileStatuses.Incomplete,
                                          Cons.fileStatuses.Active,
                                          Cons.fileStatuses.Pending,
                                      ],
                                  },
                              },
                          ],
                      },
                  }
                : {
                      where: {
                          and: [
                              { transactionId: id },
                              {
                                  status: {
                                      inq: [
                                          Cons.fileStatuses.Incomplete,
                                          Cons.fileStatuses.Active,
                                          Cons.fileStatuses.Pending,
                                      ],
                                  },
                              },
                          ],
                      },
                  };

        this.isLoading = true;
        return this.tcFileResource
            .getFiles(this.appStore.authStore.getAccessToken(), filter)
            .then((duplicates) => {
                this.duplicateFiles.clear();
                this.isLoading = false;

                if (duplicates && duplicates.length) {
                    this.duplicateFiles.replace(duplicates);
                } else {
                    this.appStore.viewStore.hideAddFileDialog();
                    if (fileType === Cons.fileTypes.transaction) {
                        return this.createFileFromTransaction(id, {
                            typeOfSale: null,
                            status: Cons.fileStatuses['Incomplete'],
                            fileSubmissionDate: moment(new Date()),
                            origin: 'Transaction',
                        }).then(() => {
                            this.appStore.viewStore.openFileDetailPageForNew(this.selectedFile);
                        });
                    } else if (fileType === Cons.fileTypes.listing) {
                        return this.createFileFromListing(id, {
                            typeOfSale: 'listing',
                            status: Cons.fileStatuses['Incomplete'],
                            origin: 'Listing',
                            fileSubmissionDate: moment(new Date()),
                            estimatedCloseDate: null,
                        }).then(() => {
                            this.appStore.viewStore.openFileDetailPageForNew(this.selectedFile);
                        });
                    } else {
                        throw new Error('File type not found');
                    }
                }
            })
            .catch((err) => {
                this.isLoading = false;
                return err;
            });
    }

    createFileFromTransaction(transactionId, defaults) {
        ModelSchemas.createTcFileSchema(TcFileModel, {
            coordinator: object(Coordinator),
            agents: list(object(Agent)),
        });
        this.selectedFile = new TcFileModel('new');
        this.selectedFileViewModel = createViewModel(this.selectedFile);
        const coordinator = this.getCoordinator();

        let newTransaction;
        return this.appStore.transactionStore
            .getTransactionsById(transactionId)
            .then(({ transaction }) => {
                newTransaction = transaction;
                return this.agentProfileResource.getAgentProfileByAgentId(
                    this.appStore.authStore.getAccessToken(),
                    newTransaction.AgentId
                );
            })
            .then((profile) => {
                const initialData = {
                    coordinatorId: coordinator,
                    propertyAddress: newTransaction.Address,
                    estimatedCloseDate: newTransaction.EscrowClosingDate
                        ? moment(newTransaction.EscrowClosingDate)
                        : null,
                    subscriberName: newTransaction.BrokerageName == undefined  || newTransaction.BrokerageName == "value" 
                                ? "" : newTransaction.BrokerageName,
                    address1: newTransaction.StreetNumber,
                    address2: newTransaction.StreetAddress,
                    city: newTransaction.City,
                    state: newTransaction.State,
                    county: newTransaction.County,
                    zip: newTransaction.Zip,
                    direction: newTransaction.StreetDirection,
                    unitNum: newTransaction.UnitNumber,
                    originId: newTransaction.TransactionId,
                    transactionId: newTransaction.TransactionId,
                    subscriberId: newTransaction.AgentSubscriberId,
                    agents: [
                        {
                            firstName: newTransaction.AgentFirstName,
                            lastName: newTransaction.AgentLastName,
                            email: newTransaction.AgentEmail,
                            agentContactId: newTransaction.AgentId,
                            name: newTransaction.AgentNameFirstLast,
                            agentProfile: profile || new AgentProfileModel(),
                            subscriberName: newTransaction.BrokerageName,
                            subscriberId: newTransaction.AgentSubscriberId,
                        },
                    ],
                };
                const newFile = _.assign(defaults, initialData);
                _.assign(this.selectedFileViewModel, newFile);
            });
    }

    createFileFromListing(listingId, defaults) {
        ModelSchemas.createTcFileSchema(TcFileModel, {
            coordinator: object(Coordinator),
            agents: list(object(Agent)),
        });
        this.selectedFile = new TcFileModel('new');
        this.selectedFileViewModel = createViewModel(this.selectedFile);

        let newListing;
        return this.appStore.listingStore
            .getListingsById(listingId)
            .then(({ listing }) => {
                newListing = listing;
                return this.agentProfileResource.getAgentProfileByAgentId(
                    this.appStore.authStore.getAccessToken(),
                    listing.ListingAgentId
                );
            })
            .then((profile) => {
                const initialData = {
                    coordinatorId: this.getCoordinator(),
                    propertyAddress: newListing.Address,
                    subscriberName: newListing.BrokerageName,
                    originId: newListing.Id,
                    subscriberId: newListing.AgentSubscriberId,
                    address1: newListing.StreetNumber,
                    address2: newListing.StreetName,
                    city: newListing.City,
                    state: newListing.State,
                    county: newListing.County,
                    zip: newListing.Zip,
                    direction: newListing.Direction,
                    unitNum: newListing.Unit,
                    agents: [
                        {
                            firstName: newListing.ListingAgentFirstName || '',
                            lastName: newListing.ListingAgentLastName || '',
                            email: newListing.AgentEmail,
                            agentContactId: newListing.ListingAgentId,
                            name: newListing.ListingAgentFirstName + ' ' + newListing.ListingAgentLastName,
                            agentProfile: profile || new AgentProfileModel(),
                            subscriberName: newListing.BrokerageName,
                            subscriberId: newListing.AgentSubscriberId,
                        },
                    ],
                };

                const newFile = _.assign(defaults, initialData);
                _.assign(this.selectedFileViewModel, newFile);
            });
    }

    @action
    updateFiles(fileModels) {
        this.files.clear();
        fileModels.forEach((newFile) => {
            this.files.set(newFile.tcFileId, newFile);
        });
    }

    getCoordinator() {
        const role = this.appStore.coordinatorDetailStore.coordinator.roles[0].name;
        return role && role === 'tc' ? this.appStore.coordinatorDetailStore.coordinator.coordinatorId : null;
    }

    @computed
    get lookupTcFilesComputed() {
        return this.lookupFiles.map((f) => {
            return {
                tcFileId: f.tcFileId,
                propertyAddress: f.propertyAddress,
                origin: f.origin,
                originId: f.originId,
                agents: f.agents,
                status: f.status,
                typeOfSale: f.typeOfSale,
                transactionId: f.transactionId,
                isTransaction: f.isTransaction,
                subscriberName: f.subscriberName,
                propertyType: f.propertyType
            };
        });
    }

    @computed
    get lookupSubcribersComputed() {
        return this.lookupSubscriberNames.map((f) => {
            return {
                subscriberid:f.subscriberid,
                subscribername: f.subscribername
            };
        });
    }

    @action.bound
    loadLookupTcFiles(query) {
        const formattedQuery = { filter: { where: { propertyAddress: { ilike: `%${query}%` } } } };
        this.tcFileResource.getTcFilesSearch(this.appStore.authStore.getAccessToken(), formattedQuery).then((files) => {
            this.lookupFiles.replace(files);
        });
    }

    @action.bound
    loadLookupSubscriberName(query) {
        this.tcFileResource.getSubscriberNameSearch(this.appStore.authStore.getAccessToken(), query).then((subcribers) => {
            if (subcribers && subcribers.length) {
                this.lookupSubscriberNames.replace(subcribers)}
        })
        .catch((err) => {
            Notifications.ToastError('Error Loading subscriber names');
            console.log(err);
        })
        ;
    }

    @computed
    get lookupAgentsComputed() {
        return this.lookupAgents.map((e) => {
            return {
                agentId: e.agentId,
                agentContactId: e.agentContactId,
                name: e.name,
                aspNetUserId: e.aspNetUserId,
                email: e.email,
                firstName: e.firstName,
                lastName: e.lastName,
            };
        });
    }

    @action.bound
    loadLookupAgents(query) {
        const formattedQuery = {
            filter: { where: { name: { ilike: `%${query}%` } } },
            firstOnField: { field: 'agentContactId', limit: 15 },
        };

        this.agentResource.getAgentsSearch(this.appStore.authStore.getAccessToken(), formattedQuery).then((agents) => {
            this.lookupAgents.replace(agents);
        });
    }

    @action.bound
    deleteFile(file) {
        this.tcFileResource
            .deleteFileById(this.appStore.authStore.getAccessToken(), file.tcFileId)
            .then(() => {
                this.appStore.viewStore.openFilesPage();
                Notifications.ToastSuccess('File Deleted');
            })
            .catch((err) => {
                Notifications.ToastError('Error Deleting File');
                console.log(err);
            });
    }

    @action.bound
    loadLookupAgentOffices(subscriberId, userId) {
        this.officeResource
            .getOffices(this.appStore.authStore.getAccessToken(), subscriberId, userId)
            .then((offices) => {
                if (_.every(offices, (x) => !x.IsSingleOfficeBroker)) {
                    this.lookupAgentOffices.replace(offices);
                }
            })
            .catch((err) => {
                Notifications.ToastError('Error Loading Offices');
                console.log(err);
            });
    }

    @action.bound
    loadLookupAgentPropertyTypes(subscriberId) {
        this.propertyTypeResource
            .getPropertyTypes(this.appStore.authStore.getAccessToken(), subscriberId)
            .then((propertyTypes) => {
                this.lookupAgentPropertyTypes.replace(propertyTypes.office);
            })
            .catch((err) => {
                Notifications.ToastError('Error Loading PropertyTypes');
                console.log(err);
            });
    }

    @action.bound
    clearLookupAgentOffices() {
        this.lookupAgentOffices.clear();
    }

    @action.bound
    clearLookupAgentPropertyTypes() {
        this.lookupAgentPropertyTypes.clear();
    }

    /**
     * ContactType is optional.  All contacts will be returned if not specified
     */
    getContactsForSelectedFile(contactType) {
        return new Promise((resolve) => {
            if (this.selectedFile.isTransaction) {
                return this.primeResource
                    .getTransactionContacts(
                        this.appStore.authStore.getAccessToken(),
                        this.selectedFile.transactionId,
                        this.selectedFile.subscriberId
                    )
                    .then((contacts) => {
                        contactType ? resolve(_.filter(contacts, { contactTypeId: contactType })) : resolve(contacts);
                    })
                    .catch(() =>{
                        this.hasErrors = true;
                    });
            } else {
                return this.primeResource
                    .getListingContacts(
                        this.appStore.authStore.getAccessToken(),
                        this.selectedFile.originId,
                        this.selectedFile.subscriberId
                    )
                    .then((contacts) => {
                        contactType ? resolve(_.filter(contacts, { contactTypeId: contactType })) : resolve(contacts);
                    }) 
                    .catch(() =>{
                        this.hasErrors = true;
                    });;
            }
        });
    }

    notExistsInSkyslope()
    {
        if (this.selectedFile.isTransaction) {
        return this.appStore.transactionStore
        .getTransactionsById(this.selectedFile.transactionId)
        .then(({ transaction }) => {
            this.hasErrors = false;
            return false;
        })
        .catch(() =>{
            this.hasErrors = true;
            return true;
        });
        }
        else
        {
            return this.appStore.listingStore
            .getListingsById(this.selectedFile.originId, this.selectedFile.subscriberId)
        .then(({ listing }) => {
            this.hasErrors = false;
            return false;
        })
        .catch(() =>{
            this.hasErrors = true;
            return true;
        });

        }
    }
    
    @action
    getSkySlopeFileForSelectedFile() {
        return new Promise((resolve) => {
            if (this.selectedFile.isTransaction) {
                return this.appStore.transactionStore
                    .getTransactionsById(this.selectedFile.transactionId)
                    .then(({ transaction }) => {
                        resolve(transaction);
                    })
                    .catch(() =>{
                        this.hasErrors = true;
                    });
            } else {
                return this.appStore.listingStore
                    .getListingsById(this.selectedFile.originId, this.selectedFile.subscriberId)
                    .then(({ listing }) => {
                        resolve(listing);
                    });
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/files/tcfile-store.js